export default __webpack_public_path__ + "static/media/XK.bbf20861.svg";